import { render, staticRenderFns } from "./DetailRiwayatPesertaRpl.vue?vue&type=template&id=b31a9d1e&scoped=true&"
import script from "./DetailRiwayatPesertaRpl.vue?vue&type=script&lang=js&"
export * from "./DetailRiwayatPesertaRpl.vue?vue&type=script&lang=js&"
import style0 from "./DetailRiwayatPesertaRpl.vue?vue&type=style&index=0&id=b31a9d1e&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31a9d1e",
  null
  
)

export default component.exports